module.exports = __webpack_public_path__ + "img/451.b680879c.jpg";